/**
 * A service that provides operations for date locale configuration
 */
export class DateLocaleService {
  constructor(private $mdDateLocale, private $translate) {
  }

  /**
   * Function to configure the $mdDateLocale service based on the currently loaded locale. This is most typically used by the md-date-picker in Angular Material, in particular the display of month and day names
   */
  public configureDateLocaleProvider() {
    const loadedLocale = this.$translate.use();
    let momentLocale;

    //There is no 'en' locale for moment.js, only en-gb so having to default here if $translate service is using en
    momentLocale = loadedLocale === 'en' ? 'en-gb' : loadedLocale;

    moment.locale(momentLocale);

    this.$mdDateLocale.months = moment.months();
    this.$mdDateLocale.shortMonths = moment.monthsShort();
    this.$mdDateLocale.days = moment.weekdays();
    this.$mdDateLocale.shortDays = moment.weekdaysShort();

    this.$mdDateLocale.formatDate = (date) => {
      return date ? moment(date).format('DD MMM YYYY') : '';
    };
    this.$mdDateLocale.parseDate = (dateString) => {
      let date;
      const validFormats = [
        'D-MMM-YY',
        'D-MMM-YYYY',
        'DD-MMM-YY',
        'DD-MMM-YYYY',
        'D-MM-YY',
        'D-MM-YYYY',
        'DD-MM-YY',
        'DD-MM-YYYY',
        'D-M-YY',
        'D-M-YYYY',
        'DD-M-YY',
        'DD-M-YYYY',
        'MMM-Do-YYYY'
      ];
      dateString = dateString.trim();
      dateString = dateString.split(' ').join('-');
      dateString = dateString.split('/').join('-');
      dateString = dateString.split('.').join('-');
      dateString = dateString.split('_').join('-');
      date = <any>moment(dateString, validFormats, momentLocale, true);
      return date.isValid() ? date.toDate() : new Date(NaN);
    };
  }
}